// Clear and update the column sorting to match the provided sort config.
export const updateColumnSort = (gridApi, sortCols) => {
  const currentColumnState = gridApi.value.getColumnState()

  const newState = currentColumnState.map((col) => {
    const savedColumn = sortCols.find((s) => (s.colId ?? s.field) === col.colId)
    return {
      ...col,
      sort: savedColumn?.sort ?? null,
      sortIndex: savedColumn?.sortIndex ?? null
    }
  })

  gridApi.value.applyColumnState({
    state: newState
  })
}

// Returns all the columns that are sorted.
export const getAllSortedColumns = (gridApi) => {
  return gridApi.value.getColumnState().filter((column) => column.sort)
}

// Returns only the sort data from the column state.
export const onlySortData = (columns) => {
  return columns.map((column) => ({
    colId: column.colId,
    sort: column.sort,
    sortIndex: column.sortIndex
  }))
}
